/* React base class */
import { Component } from "react"

/* SEO helper */
import { applySeo } from "../../helpers"

/* Shared UI components */
import { Block } from "../../components"

/* Page ProPublicOffer */
class ProPublicOffer extends Component {

    componentDidMount = () => {

        /* SEO */
        applySeo({
            title: "Публичная оферта Bookify Pro",
            description: "Публичная оферта Bookify Pro — условия использования сервиса для мастеров и организаций.",
            path: "/partner/public-offer"
        })

        /* Scroll */
        window.scroll(0, 0)
    }

    render = () => {
        return (
            <Block>
                <div className="page">
                    <div className="legal">

                        <h1>Публичная оферта на использование сервиса Bookify Pro</h1>

                        <h2>1. Общие положения</h2>
                        <p>Настоящий документ является публичной офертой (далее — «Оферта») ТОО «SARY GROUP» (далее — «Администрация») для юридических лиц и индивидуальных предпринимателей (далее — «Пользователь»), желающих использовать мобильное приложение Bookify Pro (далее — «Приложение»).</p>

                        <h2>2. Акцепт оферты</h2>
                        <p>Использование Приложения означает полное и безоговорочное принятие условий Оферты. В случае несогласия с условиями Пользователь должен прекратить использование Приложения. Акцепт Оферты считается совершённым с момента регистрации Пользователя в Приложении.</p>

                        <h2>3. Предоставляемые услуги</h2>
                        <p>Приложение предназначено для автоматизации бизнес-процессов в сфере услуг, включая, но не ограничиваясь:</p>
                        <ul>
                            <li>Ведение календаря записей клиентов;</li>
                            <li>Управление базой клиентов и историей посещений;</li>
                            <li>Создание, редактирование и удаление услуг и их стоимости;</li>
                            <li>Настройку профиля компании, способов оплаты, графика работы;</li>
                            <li>Аналитику и статистику доходов, посещений и востребованности услуг.</li>
                        </ul>

                        <h2>4. Права и обязанности сторон</h2>
                        <h3>4.1. Администрация обязуется:</h3>
                        <ul>
                            <li>Обеспечивать бесперебойную работу Приложения, за исключением случаев технического обслуживания и форс-мажорных обстоятельств.</li>
                            <li>Обеспечивать защиту персональных данных Пользователей в соответствии с действующим законодательством.</li>
                            <li>Предоставлять техническую поддержку Пользователям при возникновении вопросов по использованию Приложения.</li>
                        </ul>

                        <h3>4.2. Пользователь обязуется:</h3>
                        <ul>
                            <li>Предоставлять актуальную и достоверную информацию о себе и своей деятельности.</li>
                            <li>Не использовать Приложение для незаконных целей, в том числе мошенничества и распространения запрещённой информации.</li>
                            <li>Самостоятельно обеспечивать сохранность своих учётных данных и не передавать их третьим лицам.</li>
                        </ul>

                        <h2>5. Стоимость и расчёты</h2>
                        <p>Использование Приложения может быть платным в зависимости от выбранного тарифного плана. Актуальные тарифы указываются в соответствующем разделе Приложения. Все цены указываются и все расчёты производятся <strong>в национальной валюте Республики Казахстан — казахстанских тенге (₸, KZT)</strong>. Оплата осуществляется через встроенные платёжные системы. В случае неуплаты доступ к платным функциям Приложения может быть приостановлен.</p>

                        <h2>6. Порядок возврата денежных средств</h2>
                        <ul>
                            <li>При отказе от подписки до окончания оплаченного периода уплаченные средства за неиспользованный период могут быть возвращены по письменному обращению Пользователя.</li>
                            <li>Для возврата Пользователь направляет обращение на <a href="mailto:info@bookify.kz">info@bookify.kz</a> с указанием реквизитов оплаты. Обращение рассматривается в течение 10 (десяти) рабочих дней.</li>
                            <li>Возврат производится тем же способом и в той же валюте (казахстанских тенге), которыми была произведена оплата.</li>
                        </ul>

                        <h2>7. Ответственность сторон</h2>
                        <p>Администрация не несёт ответственности за убытки, вызванные:</p>
                        <ul>
                            <li>Некорректным использованием Приложения Пользователем;</li>
                            <li>Форс-мажорными обстоятельствами;</li>
                            <li>Техническими сбоями, возникшими по вине третьих лиц (поставщиков интернет-услуг, платёжных систем и т.д.).</li>
                        </ul>
                        <p>Пользователь несёт полную ответственность за корректность введённых данных и обязательства перед своими клиентами.</p>

                        <h2>8. Обработка персональных данных</h2>
                        <p>Регистрация в Приложении подразумевает согласие Пользователя на обработку его персональных данных в соответствии с Политикой конфиденциальности. Администрация вправе использовать анонимизированные данные для аналитики и улучшения сервиса.</p>

                        <h2>9. Урегулирование споров и применимое право</h2>
                        <p>Все споры разрешаются путём переговоров; претензия направляется на <a href="mailto:info@bookify.kz">info@bookify.kz</a> и рассматривается в течение 15 (пятнадцати) рабочих дней. При недостижении согласия спор подлежит разрешению в судебном порядке по месту нахождения Администрации. Оферта регулируется и толкуется в соответствии с действующим <strong>законодательством Республики Казахстан</strong>.</p>

                        <h2>10. Изменения в оферте</h2>
                        <p>Администрация оставляет за собой право вносить изменения в Оферту в одностороннем порядке. Обновлённый документ вступает в силу с момента публикации в Приложении. Пользователь обязан самостоятельно следить за актуальностью условий.</p>

                        <h2>11. Контакты</h2>
                        <ul>
                            <li><strong>ТОО «SARY GROUP»</strong></li>
                            <li><strong>БИН:</strong> 240440023071</li>
                            <li><strong>Email:</strong> <a href="mailto:info@bookify.kz">info@bookify.kz</a></li>
                            <li><strong>Телефон:</strong> +7 (707) 138-51-00</li>
                            <li><strong>Адрес:</strong> Казахстан, г. Алматы, микрорайон Мамыр 1, 26, БЦ Quorum, 508 кабинет</li>
                        </ul>

                    </div>
                </div>
            </Block>
        )
    }
}

/* Export */
export default ProPublicOffer
